import { render, staticRenderFns } from "./leaveRecords.vue?vue&type=template&id=862e60a8&scoped=true"
import script from "./leaveRecords.vue?vue&type=script&lang=js"
export * from "./leaveRecords.vue?vue&type=script&lang=js"
import style0 from "./leaveRecords.vue?vue&type=style&index=0&id=862e60a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862e60a8",
  null
  
)

export default component.exports